import { Layout } from '@docma-mm-core/layout/layout';
import { Structure } from '@docma-mm-core/structure/structure';
import { Project } from '@docma-mm-core/project/project';
import { MmFilterTag } from './tag/mm-filter-tag';

export class MmFilterModel {

  project: Project;
  layout: Layout;
  structure: Structure;
  tags: MmFilterTag[];

  constructor(init?: Partial<MmFilterModel>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  getTag(id: string): MmFilterTag {
    if (!this.tags) {
      return null;
    }
    return this.tags.find(t=> t.id === id);
  }

}
